import * as React from "react";

const SvgMoments = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.00008 1C2.00008 0.447715 2.4478 0 3.00008 0H12.3334C12.8857 0 13.3334 0.447715 13.3334 1H2.00008ZM3.00008 2C2.4478 2 2.00008 2.44772 2.00008 3H13.3334C13.3334 2.44772 12.8857 2 12.3334 2H3.00008ZM3.00008 16C2.4478 16 2.00008 15.5523 2.00008 15H13.3334C13.3334 15.5523 12.8857 16 12.3334 16H3.00008ZM4 11.3333V6.66667H11.3333V11.3333H4ZM2 5.66667C2 5.11438 2.44772 4.66667 3 4.66667H12.3333C12.8856 4.66667 13.3333 5.11438 13.3333 5.66667V12.3333C13.3333 12.8856 12.8856 13.3333 12.3333 13.3333H3C2.44771 13.3333 2 12.8856 2 12.3333V5.66667Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgMoments;
